/**
 * Returns the flex styles for a given text length.
 *
 * This is used to truncate text in a collection list.
 */
export function getFlexStyles(
  len: number,
  otherLen: number
): React.CSSProperties {
  // always allow truncation fallback
  const base = {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
  };

  // if this text is “short”, don’t flex. let it size itself
  if (len <= 10) {
    return {...base, flex: '0 0 auto'};
  }

  // if both are "very long", split 50/50
  if (len > 10 && otherLen > 10) {
    return {...base, maxWidth: '50%'};
  }

  // if this is more than twice as long as the other, cap to a larger max width
  if (otherLen > 0 && len / otherLen >= 2) {
    return {...base, maxWidth: '75%'};
  }

  return base;
}
